import { render } from "./Noun.vue?vue&type=template&id=9d735964&ts=true"
import script from "./Noun.vue?vue&type=script&lang=ts"
export * from "./Noun.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/isamu/ss/nouns/nounslove-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__